import { BcAntenatalRadioTextboxField } from "@/Patient/Models/ObstetricalFile/BritishColumbia/BcAntenatalRadioTextboxField";

class MedicalHistoryEndocrine {
    public HasEndocrine?: boolean = null;
    public HasPreviousGestationalDiabetesMellitus?: boolean = null;
    public HasThyroid?: boolean = null;
    public Other: BcAntenatalRadioTextboxField;
    public HasType1Diabetes?: boolean = null;
    public HasType2Diabetes?: boolean = null;

    public constructor(fields?: Partial<MedicalHistoryEndocrine>) {
        Object.assign(this, fields);
        this.Other = new BcAntenatalRadioTextboxField(fields?.Other);
    }

    public hasSelectedAnyMedicalHistoryEndocrine(): boolean {
        return this.HasPreviousGestationalDiabetesMellitus
            || this.HasThyroid
            || this.HasType1Diabetes
            || this.HasType2Diabetes
            || this.Other.hasSelected();
    }
}

export { MedicalHistoryEndocrine };
